import { Close } from 'components/ui/Icons';

import ActionButton from '../ActionButton';

import { defaultTheme } from '@/theme';

type DeleteButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  className?: string;
  width?: number;
  height?: number;
  iconSize?: number;
};

const DeleteButton = ({ onClick, disabled, className, width, height, iconSize }: DeleteButtonProps) => {
  return (
    <ActionButton disabled={disabled} onClick={onClick} className={className} width={width} height={height}>
      <Close
        width={iconSize ?? 20}
        height={iconSize ?? 20}
        color={disabled ? defaultTheme.mantineColors.gray[4] : defaultTheme.mantineColors.gray[7]}
      />
    </ActionButton>
  );
};

export default DeleteButton;
